<template>
    <ProgressBar v-if="loading" mode="indeterminate" style="height: 3px" class="z-5 progress-bar"></ProgressBar>
    <div class="header border-bottom-1 border-200 z-3">
        <div class="text-color text-xl flex align-items-center">
            <Button @click="goBack" icon="pi pi-arrow-left" text rounded aria-label="Filter" severity="secondary" />
            <span class="ml-2 text-overflow-ellipsis white-space-nowrap overflow-hidden"
                :style="{ maxWidth: `${larguraDaTela - 100}px` }">{{
                aula.tituloPlano }}</span>

        </div>
    </div>

    <Sidebar />

    <div class="main h-screen w-screen surface-50">
        <div class=" h-full w-full overflow-x-hidden ">
            <router-view></router-view>
        </div>
    </div>
</template>

<script setup>

import { ref } from 'vue'
import Sidebar from '@/components/layout/Sidebar.vue'
import ProgressBar from 'primevue/progressbar';
import { useRouter } from 'vue-router';
import Button from 'primevue/button';

import { useStore } from 'vuex'
import { computed } from 'vue'
const store = useStore()
const aula = computed(() => store.state.aula)

const loading = computed(() => store.state.loading);

const larguraDaTela = ref(window.innerWidth);

const router = useRouter();

function goBack() {
    router.push({ path: '/estudante/aulas' });
}



</script>

<style scoped>
@media screen and (min-width: 768px) {
    .sidebar+.main {
        padding-left: 80px;
    }
}

@media screen and (max-width: 768px) {
    .sidebar+.main {
        padding-bottom: 65px;
    }
}

.p-progressbar {
    background-color: #fff;
}

.p-progressbar {
    position: fixed;
    top: 0;
    width: 100%;
}

.header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
    box-sizing: border-box;
    background-color: #fff;
}
</style>
